export const getNewspaperPrice = (difficulty: number): number => {
  return difficulty + 1;
};
